<template>
  <div class="modalDetails">
    <div
      style="border-radius:10px;padding:10px;max-height:80vh"
      class="card has-text-centered"
    >
      <h2 class="has-text-centered sous-titre">
        {{ $t("admin.participantsCamembert.resultats") }}{{ " " }}
        <span class="bold"
          >{{ propsParticipant.firstname }}
          {{ propsParticipant.lastname }}</span
        >
      </h2>
      <p>
        {{ $t("admin.telephone") }}
        {{ propsParticipant.telephone ? propsParticipant.telephone : "--" }}
      </p>
      <div class="column mt-1" align="center">
        <div class="is-inline">
          <!-- bleu -->
          <button
            :style="buttons.tabColorAdminResultats[0]"
            class="button sizeColor mr-1"
          >
            {{ seriesButtonsPopUpDetails[1] }}
          </button>
          <!-- rouge -->
          <button
            :style="buttons.tabColorAdminResultats[1]"
            class="button sizeColor mr-1"
          >
            {{ seriesButtonsPopUpDetails[0] }}
          </button>
          <!-- jaune -->
          <button
            :style="buttons.tabColorAdminResultats[2]"
            class="button sizeColor mr-1"
          >
            {{ seriesButtonsPopUpDetails[3] }}
          </button>
          <!-- vert -->
          <button
            :style="buttons.tabColorAdminResultats[3]"
            class="button sizeColor mr-1"
          >
            {{ seriesButtonsPopUpDetails[2] }}
          </button>
          {{ " " }}
        </div>
      </div>
      <div   style="overflow:auto;max-height:60vh" >
      <b-table :data="JSON.parse(propsParticipant.resultats)">
        <template>
          <b-table-column width="40" sortable label="N°" v-slot="props">{{
            props.row.id
          }}</b-table-column>

          <b-table-column
            width="100"
            sortable
            label="Question"
            v-slot="props"
            >{{ $t(props.row.q) }}</b-table-column
          >

          <b-table-column
            v-slot="props"
            centered
            width="100"
            sortable
            :label="$t('admin.profil.dominant')"
          >
            <!-- bleu -->
            <div
              v-if="props.row.prop[0].c === buttons.tabColorsStr[1]"
              :style="buttons.tabColorbackground[0]"
              class="is-rounded button size-details-reponse-color"
            />
            <!-- rouge -->
            <div
              v-if="props.row.prop[0].c === buttons.tabColorsStr[0]"
              :style="buttons.tabColorbackground[1]"
              class="is-rounded button size-details-reponse-color"
            />
            <!-- jaune -->
            <div
              v-if="props.row.prop[0].c === buttons.tabColorsStr[3]"
              :style="buttons.tabColorbackground[2]"
              class="is-rounded button size-details-reponse-color"
            />
            <!-- vert -->
            <div
              v-if="props.row.prop[0].c === buttons.tabColorsStr[2]"
              :style="buttons.tabColorbackground[3]"
              class="is-rounded button size-details-reponse-color"
            />
          </b-table-column>
        </template>
      </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import buttons from "../../data/questions.json";

export default {
  props: [
    "propsParticipant",
    "seriesButtonsPopUpDetails",
    "isDetailsModalActive",
  ],
  data() {
    return {
      buttons: buttons,
      lienParticipants: this.lienParticipants,
    };
  },
};
</script>
<style scoped>
.modalDetails {
  font-size: 12px;
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 50px;
}
</style>
